import script from "./ChatFavouritePanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatFavouritePanel.vue?vue&type=script&setup=true&lang=ts"

import "./ChatFavouritePanel.vue?vue&type=style&index=0&id=78c2f9bc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78c2f9bc"]])

export default __exports__